import * as React from "react";
import { useMergeRefs } from "@floating-ui/react";
import clsx from "clsx";
import { EqualHeightContext } from "../equal-height-provider/equal-height-provider.mjs";
const EqualHeight = (props) => {
  const { addElementToGroup, groupHeights, triggerUpdate } = React.useContext(EqualHeightContext);
  const { align = "top", className, elementRef: elementRefProp, group, children, onHeightChange } = props;
  const element = React.useRef(null);
  const innerElement = React.useRef(null);
  const innerElementHeight = React.useRef(0);
  const firstHeightChange = React.useRef(true);
  const elementRef = useMergeRefs([elementRefProp, element]);
  const getHeightByElement = React.useCallback(
    (element2, elementGroup) => {
      const groupKey = Object.keys(groupHeights).find((key) => key === elementGroup);
      if (groupKey) {
        const elGroup = groupHeights[groupKey].find((group2) => group2.elements.some(({ element: groupElement }) => groupElement === element2));
        return elGroup ? elGroup.height : 0;
      }
      return 0;
    },
    [groupHeights]
  );
  const height = element.current ? getHeightByElement(element.current, props.group) : 0;
  React.useEffect(() => {
    if (innerElement.current) {
      innerElementHeight.current = innerElement.current.clientHeight;
      const resizeObserver = new ResizeObserver((entries) => {
        requestAnimationFrame(() => {
          for (const entry of entries) {
            if (innerElementHeight.current !== entry.borderBoxSize[0].blockSize) {
              innerElementHeight.current = entry.borderBoxSize[0].blockSize;
              triggerUpdate();
            }
          }
        });
      });
      resizeObserver.observe(innerElement.current);
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [triggerUpdate]);
  React.useEffect(() => {
    if (firstHeightChange.current) {
      firstHeightChange.current = false;
      return;
    }
    if (onHeightChange) {
      onHeightChange();
    }
  }, [height, onHeightChange]);
  React.useEffect(() => {
    if (element.current && innerElement.current) {
      addElementToGroup(group, element.current, innerElement.current);
    }
  }, [addElementToGroup, elementRef, group]);
  React.useEffect(() => {
    triggerUpdate();
    return () => {
      triggerUpdate();
    };
  }, [triggerUpdate]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx("equal-height", "equal-height--".concat(align), className),
      ref: elementRef,
      style: {
        minHeight: Math.max(height, 1) + "px"
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "equal-height__inner", ref: innerElement }, children)
  );
};
export {
  EqualHeight
};
